import { useEffect, useState } from 'react'
import LikeDisLike from '../../../player-components/likeDisLike/likeDisLike'
import ShareDialog from '../../../player-components/share/shareDialog'
import { useAppDispatch, useAppSelector } from 'redux-share/hooks'
import { conditions, videoTag } from 'helpers'
import { setClearPopoversSlice } from 'redux-share/slices/popoversSlice'
import { ConditionName } from 'interfaces'
import ShareIcon from '../../../icon-components/shareIcon';
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";
import MarkersList from '../../../player-components/markersList/markersList'

const Chat = dynamic(() => import("../../../player-components/chat/chat"));
const MultiLive = dynamic(() => import("../../../player-components/multiLive/multiLive"));
const PersonalMarkersPopover = dynamic(() => import("../../../player-components/personalMarkers/personalMarkers"));
const Bookmark = dynamic(() => import("../../../player-components/bookmark/bookmark"));
const Download = dynamic(() => import("../../../player-components/download/download"));
const PlayListTab = dynamic(() => import("../../../player-components/playList/playlistTab"));
const Feedback = dynamic(() => import("../../../player-components/feedback/feedback"));

const PortraitControlbar = () => {

  const dispatch = useAppDispatch();

  const [showShareDialog, setShowShareDialog] = useState<boolean>(false)
  const [videoCurrentTime, setVideoCurrentTime] = useState<number>(0);

  useAppSelector(({ chats: { chatEnabled } }) => ({ chatEnabled }), shallowEqual);

  useEffect(() => {
    if (showShareDialog) setVideoCurrentTime(videoTag().currentTime)
  }, [showShareDialog])

  const handleShowSharePopover = () => {
    dispatch(setClearPopoversSlice())
    setShowShareDialog(true)
  }

  return (
    <div
      className={`pl-text-white pl-text-[14px] pl-flex pl-flex-nowrap pl-items-center pl-gap-2 pl-overflow-x-auto pl-border-b pl-border-secondary-500 pl-pb-4 no-scrollbar`}>
      <LikeDisLike />
      {conditions(ConditionName.chatEnabled) && <Chat />}
      {conditions(ConditionName.showMultiLive) && <MultiLive />}
      {conditions(ConditionName.hasMarkers) && <MarkersList />}
      {conditions(ConditionName.showPersonalMarker) && <PersonalMarkersPopover />}
      {conditions(ConditionName.showBookmark) && <Bookmark />}
      {conditions(ConditionName.hasDownloadLinks) && <Download />}
      <div
        className='pl-flex pl-items-center pl-gap-[14px] pl-rounded-[20px] pl-text-secondary-700 dark:pl-text-secondary-50 pl-bg-gray-100 dark:pl-bg-dark-3 pl-px-4 pl-py-[7px] pl-cursor-pointer'
        onClick={handleShowSharePopover}>
        <ShareIcon
          className={`pl-flex pl-items-center pl-w-15 pl-h-15 pl-fill-gray-800 dark:pl-fill-white pl-relative`} />
        <span className='pl-whitespace-nowrap'>اشتراک گذاری</span>
      </div>
      {conditions(ConditionName.showPlayListTabTouchscreen) && <PlayListTab/>}
      {conditions(ConditionName.showFeedback) && <Feedback />}
      <ShareDialog currentTime={videoCurrentTime} status={showShareDialog} onClose={setShowShareDialog} />

    </div>
  )
}

export default PortraitControlbar